import PropTypes from 'prop-types'
import classNames from 'classnames'
import Link from 'next/link'

import generateRoute from 'helpers/generateRoute'

import s from './Link.module.css'
import { useAtom } from 'jotai'
import { currentSiteAtom } from '../../lib/atoms'

function LinkInternal({
  href: initialHref = '',
  label = null,
  children = null,
  className = '',
  type = null,
  site = null,
}) {
  const [currentSite] = useAtom(currentSiteAtom)
  // An explicit site slug wins; otherwise link within the current site. When
  // neither is known (e.g. the root location selector) this yields "/null/..."
  // as before; don't switch to '', which generateRoute would turn into a
  // protocol-relative "//slug" URL pointing at another host.
  const sitePrefix = site || currentSite?.path.replace(/\//g, '') || null
  const { href, as } = generateRoute({ type, slug: initialHref }, sitePrefix)

  return (
    <Link href={href} as={as} className={classNames(s.container, className)}>
      {children || label}
    </Link>
  )
}

LinkInternal.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  as: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  site: PropTypes.string,
}

export default LinkInternal
